import React, { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import MDButton from "components/MDButton";
import SocialReportStepper from "./Stepper/SocialReportStepper";
import WorkspaceService from "services/workspace-service";
import ReportGenService from "services/reportgen-service";
import Card from "@mui/material/Card";

function SocialReport({ goBack, onComplete, editReportData, showNotification, entitlements }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSave = async (data) => {
        try {
            setLoading(true);
            setError("");

            // 1. Save/Update Schedule
            if (editReportData && editReportData.id) {
                await WorkspaceService.updateWorkspaceReport(editReportData.id, data);
            } else {
                await WorkspaceService.createWorkspaceReport(data);
            }

            // 2. Check for Immediate Send
            let message = "";
            let title = "Report Scheduled";
            if (data.sendImmediate) {
                console.log("🚀 User requested immediate send. Triggering email...");

                // Reconstruct data for ReportGenService
                const { config } = data;
                const periodDates = calculateDateRange(config.period);

                const profileData = config.selectedProfiles.map(p => ({
                    profileId: p.id,
                    platform: p.platform,
                    name: p.name,
                    profilePictureUrl: p.profilePictureUrl,
                    ...periodDates
                }));

                await ReportGenService.emailReport(
                    profileData,
                    false, // isPredictionEnabled
                    config.visibleCharts,
                    config.chartConfigs,
                    data.recipient_emails || [], // Ensure array
                    config.branding_pack_id,
                    config.target_client
                );
                console.log("✅ Immediate report email sent.");
                title = "Report Sent";
                message = "Your report has been generated and sent to the recipient emails provided.";
            } else {
                message = "Your report has been updated and scheduled successfully.";
            }

            // 3. Trigger Parent Notification (Persistent)
            if (showNotification) {
                showNotification("success", "check", title, message);
            }

            // 4. Navigate Back (Closes Config)
            goBack();

        } catch (err) {
            console.error("Error saving/sending report:", err);
            setError("Failed to save report. Please try again.");
            if (showNotification) {
                showNotification("error", "warning", "Error", "Failed to save report. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    // Helper to calculate dates based on period string (duplicated from ReportConfiguration for now)
    const calculateDateRange = (period) => {
        const toDate = new Date();
        let fromDate = new Date();

        if (period === "last_7_days") fromDate.setDate(toDate.getDate() - 7);
        else if (period === "last_14_days") fromDate.setDate(toDate.getDate() - 14);
        else if (period === "last_3_months") fromDate.setMonth(toDate.getMonth() - 3);
        else fromDate.setDate(toDate.getDate() - 30); // Default last_30_days

        return {
            fromDate: fromDate.toISOString(),
            toDate: toDate.toISOString()
        };
    };

    return (
        <MDBox>
            {error && (
                <MDBox mb={2} px={2}>
                    <MDTypography color="error">{error}</MDTypography>
                </MDBox>
            )}

            <SocialReportStepper
                editReportData={editReportData}
                onComplete={handleSave}
                onCancel={goBack}
                isSaving={loading}
                entitlements={entitlements}
            />
        </MDBox>
    );
}

export default SocialReport;
